import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import FastqFileType from 'const/enums/FastqFileType';
var rReadRegex = /_R([12])(?:_\d{3})?/;
var underscoreReadRegex = /_([12])(?:_\d{3})?\.(fastq|fq)\.gz$/;
var getPairData = function getPairData(fileName) {
  var name = fileName;
  var matcher = name.match(rReadRegex) ? rReadRegex : underscoreReadRegex;
  var readMatch = name.match(matcher);
  var _readMatch = _slicedToArray(readMatch, 2),
    readNumberStr = _readMatch[1];
  name = name.replace(matcher, '');
  name = name.replace(/\.(fastq|fq)\.gz$/, '');
  return {
    name: name,
    readNumber: parseInt(readNumberStr, 10)
  };
};
var getMatchingPairFor = function getMatchingPairFor(fileName) {
  var matcher = fileName.match(rReadRegex) ? rReadRegex : underscoreReadRegex;
  var matchingPair = fileName.replace(matcher, function (match, group1) {
    var otherNumber = group1 === '1' ? '2' : '1';
    return match.replace(group1, otherNumber);
  });
  return matchingPair;
};
var hasReadPair = function hasReadPair(fileName) {
  return rReadRegex.test(fileName) || underscoreReadRegex.test(fileName);
};

// This function assumes that the files are already paired correctly,
// no checks are done on that end
var getPairsForFiles = function getPairsForFiles(files) {
  var pairs = _defineProperty(_defineProperty({}, FastqFileType.IMMUNE_FASTQ, {}), FastqFileType.WT_FASTQ, {});
  Object.values(files).forEach(function (file) {
    var _pairs$file$type, _pairs$file$type$pair;
    if (file.type === 'samplelt') return;
    var _getPairData = getPairData(file.name),
      pairName = _getPairData.name,
      readNumber = _getPairData.readNumber;
    var pairData = (_pairs$file$type$pair = (_pairs$file$type = pairs[file.type])[pairName]) !== null && _pairs$file$type$pair !== void 0 ? _pairs$file$type$pair : _pairs$file$type[pairName] = [];

    // reads are 1 or 2, we want to store them in the array at index 0 or 1
    pairData[readNumber - 1] = file.id;
  });

  // Validate that every pair has exactly R1 and R2
  Object.values(pairs).forEach(function (typeObj) {
    Object.values(typeObj).forEach(function (filesArr) {
      if (filesArr.length !== 2 || filesArr.includes(undefined)) {
        throw new Error('Invalid number of files per pair');
      }
    });
  });
  return pairs;
};
export { getPairsForFiles, getMatchingPairFor, hasReadPair, getPairData };